// Redux Persist 持久化组件
// 用于在应用启动时恢复持久化的状态

import React from 'react'
import { PersistGate } from 'redux-persist/integration/react'
import { Spin } from 'antd'
import { persistor } from '@/store'

interface CustomPersistGateProps {
  children: React.ReactNode
}

// 加载中的组件
const LoadingComponent = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    flexDirection: 'column',
    gap: '16px'
  }}>
    <Spin size="large" />
    <div>正在恢复应用状态...</div>
  </div>
)

// 自定义 PersistGate 组件
const CustomPersistGate: React.FC<CustomPersistGateProps> = ({ children }) => {
  return (
    <PersistGate 
      loading={<LoadingComponent />} 
      persistor={persistor}
    >
      {children}
    </PersistGate>
  )
}

export default CustomPersistGate
